import React from 'react';
import PolicyLayout from './PolicyLayout';

const ShippingPolicyPage: React.FC = () => (
  <PolicyLayout title="Shipping Policy" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Shipping Coverage</h2>
      <p>We currently ship across all states and union territories in India. International shipping is not available at this time.</p>
    </section>

    <section>
      <h2>2. Shipping Charges</h2>
      <ul>
        <li><strong>Free Shipping</strong> on all orders — no minimum order value</li>
        <li>No hidden delivery charges at checkout</li>
      </ul>
    </section>

    <section>
      <h2>3. Delivery Timeframes</h2>
      <ul>
        <li><strong>Metro cities</strong> (Delhi, Mumbai, Bangalore, Chennai, Kolkata, Hyderabad): 3–5 business days</li>
        <li><strong>Other cities and towns:</strong> 5–7 business days</li>
        <li><strong>Remote areas:</strong> 7–10 business days</li>
      </ul>
      <p>Delivery times are estimates and may vary due to courier delays, public holidays, or weather conditions.</p>
    </section>

    <section>
      <h2>4. Order Processing Time</h2>
      <p>Orders are processed within <strong>1–2 business days</strong> after payment confirmation. Orders placed on weekends or public holidays are processed the next business day.</p>
    </section>

    <section>
      <h2>5. Order Tracking</h2>
      <p>Once your order is shipped, you can track it from the <strong>My Orders</strong> section in your account. A tracking number will be assigned once the order is dispatched.</p>
    </section>

    <section>
      <h2>6. Delivery Attempts</h2>
      <ul>
        <li>Our courier partner will attempt delivery up to 3 times</li>
        <li>If all attempts fail, the order will be returned to our warehouse</li>
        <li>A re-delivery may be arranged upon request</li>
        <li>Re-delivery charges may apply for failed deliveries due to customer unavailability</li>
      </ul>
    </section>

    <section>
      <h2>7. Damaged in Transit</h2>
      <p>If your package arrives visibly damaged, please:</p>
      <ol>
        <li>Take photos before opening</li>
        <li>Email us at <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong> within 24 hours</li>
        <li>We will arrange a replacement or full refund</li>
      </ol>
    </section>

    <section>
      <h2>8. Address Accuracy</h2>
      <p>Please ensure your delivery address is complete and accurate. Sasta Fashions is not responsible for delays or non-delivery due to incorrect or incomplete address information provided by the customer.</p>
    </section>

    <section>
      <h2>9. Contact</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default ShippingPolicyPage;
